// مجرد استديو — Design tokens (matches V1 reference palette)

export const T = {
    // ── Backgrounds ─────────────────────────────────────────────────────────────
    bg:      '#EDEAFB',   // lavender page background
    bgCard:  '#FAF8FF',   // card background
    bgWhite: '#FFFFFF',   // white section background

    // ── Text ────────────────────────────────────────────────────────────────────
    ink:   '#0E0B2E',
    ink70: 'rgba(14, 11, 46, 0.72)',
    ink50: 'rgba(14, 11, 46, 0.52)',
    ink20: 'rgba(14, 11, 46, 0.14)',
    line:  'rgba(14, 11, 46, 0.10)',

    // ── Brand (indigo) ───────────────────────────────────────────────────────────
    brand:     '#5B4FE5',
    brand300:  '#A291E3',
    brand400:  '#7E67D6',
    brand100:  '#E4DEF7',
    brandGlow: 'rgba(91,79,229,0.28)',
    brandDim:  'rgba(91,79,229,0.12)',

    // ── Accents ──────────────────────────────────────────────────────────────────
    amber: '#F2C94C',
    coral: '#FF8A65',
    mint:  '#6FE3C1',

    // ── Radius ───────────────────────────────────────────────────────────────────
    rSm:  '8px',
    rMd:  '14px',
    rLg:  '22px',
    rXl:  '32px',
    r2Xl: '44px',
    rPill:'999px',
} as const;
